<template>
  <div class="mt-4 flex justify-between">
    <h2 class="text-xl leading-tight font-semibold text-gray-800 dark:text-gray-200">
      <slot />
    </h2>

    <div><slot name="actions" /></div>
  </div>
</template>
